module.exports = __webpack_public_path__ + "img/submit.cd4cb12c.png";